<template>
  <div class="flex gap-2 items-center flex-nowrap">
    <img
      src="@/assets/images/profile/user-1.jpg"
      alt="profile-pic"
      class="w-10 h-10 rounded-full"
    />
    <div class="flex flex-col">
      <p class="text-xs text-stone-400">
        {{ note?.user?.name && note?.user?.name + ','
         }} {{ formatDate(note?.created_at) }}
      </p>
      <div class="p-2 text-sm bg-gray-200 rounded-lg">
        {{ note?.description }}
      </div>
    </div>
  </div>
</template>

<script setup>
import moment from "jalali-moment";
import { defineProps } from "vue";

defineProps({
  note: {
    type: Object,
    required: true,
  },
});

function formatDate(isoDateString) {
  const now = moment();
  const date = moment(isoDateString);

  const diffInMinutes = now.diff(date, "minutes");

  if (diffInMinutes === 0) {
    return "همین الان";
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes} دقیقه پیش`;
  } else {
    const persianDate = date.format("jYYYY/jMM/jDD hh:mm");
    return persianDate;
  }
}
</script>
